/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseBlogCategoryFragment = gql`
  fragment BaseBlogCategoryFragment on BlogCategory {
    description
    name
    parentCategory {
      __typename
      ... on Entry {
        sys {
          id
        }
      }
    }
    slug
    sys {
      id
    }
  }
`;
